import React from 'react';
import { Dropdown } from 'antd';
import classNames from 'classnames';

import BaseButton from '.';
import s from './style.module.scss';

import type { DropdownProps } from 'antd';
import type { IBaseButtonProps } from '.';

export interface IBaseDropdownButtonProps extends IBaseButtonProps {
  items: Array<{
    key: string;
    label: React.ReactNode;
    className?: string;
    dataCy?: string;
    disabled?: boolean;
    visible?: boolean;
    onClick?: (...args: any) => void;
  }>;
  dropdownProps?: DropdownProps;
}

const BaseDropdownButton: React.FC<IBaseDropdownButtonProps> = (props) => {
  const {
    items,
    dataCy = 'base-dropdown-button',
    dropdownProps,
    ...args
  } = props;

  const mapedItems = items
    .filter((el) => !el.visible)
    .map((el) => {
      const cy = el.dataCy ?? `${dataCy}-${el.key}`;
      return {
        ...el,
        label: (
          <div data-cy={cy} className={el.className}>
            {el.label}
          </div>
        ),
      };
    });

  return (
    <>
      <Dropdown
        trigger={['click']}
        menu={{ items: mapedItems }}
        {...dropdownProps}
        rootClassName={classNames(s.menu, dropdownProps?.rootClassName)}
      >
        <BaseButton {...args} dataCy="dropdown-button" />
      </Dropdown>
    </>
  );
};

export default BaseDropdownButton;
